/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Search text dynamic */
const words = [
  "¿Qué estás buscando?",
  "Emulsión hidratante corporal",
];
let cont = 0;
let timer;
let id_placeholder = "typer";
if (screen.width <= 640 && document.getElementById("inp3")) {
  id_placeholder = "inp3";
}
function typingEffect() {
  let word = words[cont].split("");
  var loopTyping = function () {
    if (word.length > 0) {
      let elem = document.getElementById(id_placeholder);
      elem.setAttribute(
        "placeholder",
        elem.getAttribute("placeholder") + word.shift()
      );
    } else {
      deletingEffect();
      return false;
    }
    timer = setTimeout(loopTyping, 120);
  };
  loopTyping();
}
function deletingEffect() {
  let word = words[cont].split("");
  var loopDeleting = function () {
    if (word.length > 0) {
      word.pop();
      document
        .getElementById(id_placeholder)
        .setAttribute("placeholder", word.join(""));
    } else {
      if (words.length > cont + 1) {
        cont++;
      } else {
        cont = 0;
      }
      typingEffect();
      return false;
    }
    timer = setTimeout(loopDeleting, 100);
  };
  loopDeleting();
}
//typingEffect();

/* Toggle close results */
function toggleX() {
  var inp3 = document.getElementById("inp3").value;
  if (document.getElementById("inp3").value.trim() == "") {
    document.getElementById("closeSearchBar").style.display = "none";
  } else {
    document.getElementById("closeSearchBar").style.display = "block";
  }
}
function resultsHide() {
  document
    .getElementById("Search__ResultsMobile")
    .setAttribute("aria-hidden", "true");
  document.getElementById("Search__FormMobile").reset();
  document.getElementById("closeSearchBar").style.display = "none";
}
function toggleUnfolded() {
  var inp3 = document.getElementById("typer").value;
  if (document.getElementById("typer").value.trim() == "") {
    document.getElementById("closeSearchBarUnfolded").style.display = "none";
  } else {
    document.getElementById("closeSearchBarUnfolded").style.display = "block";
  }
}
function resultsHideUnfolded() {
  document
    .getElementById("Search__ResultsUnfolded")
    .setAttribute("aria-hidden", "true");
  document.getElementById("Search__FormUnfolded").reset();
  document.getElementById("closeSearchBarUnfolded").style.display = "none";
}

/* Search bar effect */
var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;

  if (window.innerWidth < 641) {
    if (prevScrollpos >= currentScrollPos) {
      document.getElementById("shopify-section-search-bar").style.top = "64px";
      document.getElementById("shopify-section-search-bar").style.zIndex = "3";
    } else {
      var attr = document
        .getElementById("Search__ResultsMobile")
        .getAttribute("aria-hidden");
      if (attr == "true") {
        document.getElementById("shopify-section-search-bar").style.top = "0px";
      }
    }
    prevScrollpos = currentScrollPos;
  }
};



function showSizes(productId){
  
  
  var allElements = document.querySelectorAll('*[id^="sizes_"]');
  allElements.forEach(function(elementItem) {
    elementItem.classList.add("hidden-tablet-and-up");
    elementItem.classList.add("hidden-phone");
    elementItem.classList.remove("Sizes");
  });
  
  var element = document.getElementById('sizes_' + productId + '');
  element.classList.remove("hidden-tablet-and-up");
  element.classList.remove("hidden-phone");
  element.classList.add("Sizes");
}


function addItemToCart(product_id, variant_id, qty, frequency) {
  data = {
    "id": variant_id,
    "quantity": qty
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));

      var element = document.getElementById('sizes_' + product_id);
      element.classList.add("hidden-tablet-and-up");
      element.classList.add("hidden-phone");
      element.classList.remove("Sizes");
      

    }
  });
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true    // same code for prestige theme   
  }));
}

const swiper = new Swiper('.swiper', {
  // Default parameters
  slidesPerView: 2,
  spaceBetween: 10,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 6,
      spaceBetween: 40
    }
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  }
})

